export default "__VITE_ASSET__nCB_TIvL__"